import { render, staticRenderFns } from "./TextIconCards.vue?vue&type=template&id=0a3d3d30"
import script from "./TextIconCards.vue?vue&type=script&lang=js"
export * from "./TextIconCards.vue?vue&type=script&lang=js"
import style0 from "./TextIconCards.vue?vue&type=style&index=0&id=0a3d3d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports